import kr from '../kr/kr';
import HTMLClass from '../kr/utils/HTMLClass';

export default class Tabs extends kr.Component {
    init() {
        this.$tabs = this.$element.querySelectorAll('div[data-tab]');
        this.hash = window.location.hash ? window.location.hash : null;
        
        this.checkHash();

        this.bind();
    }

    checkHash()
    {
        if (!this.hash) {
            return;
        }

        const hash = this.hash.replace('#', '');
        const el = this.$element.querySelector(`a[data-tab-button="${hash}"]`);
        if (!el) {
            return;
        }

        this._toggle(el);
    }

    bind()
    {
        this.on('click', 'a[data-tab-button]', (target, event) => {
            event.preventDefault();
            this._toggle(target);
        });
    }

    _toggle(target)
    {
        const name = target.getAttribute('data-tab-button');
        if (typeof name === 'undefined' || !name) {
            return false;
        }
        this.$element.querySelectorAll('a[data-tab-button]').forEach(item => {
            HTMLClass.removeClass(item, 'tabs__header__item--active');
        });
        HTMLClass.addClass(target, 'tabs__header__item--active');
        this.$tabs.forEach(item => {
            
            if (item.getAttribute('data-tab') == name) {
                HTMLClass.addClass(item, 'tabs__content__item--active');
            } else {
                HTMLClass.removeClass(item, 'tabs__content__item--active');
            }
        });
    }
    
}

kr.registerComponent('.js-tabs', {
    component: Tabs
});